// Export all auth helpers
export { default as AuthenticationHelper } from './authentication';
export { default as RegistrationHelper } from './registration';

export { default as ProfileHelper } from './profile';

// Combined auth helper for convenience
import AuthenticationHelper from './authentication';
import RegistrationHelper from './registration';

import ProfileHelper from './profile';

export const AuthHelpers = {
    auth: AuthenticationHelper,
    registration: RegistrationHelper,

    profile: ProfileHelper
};

export default AuthHelpers;
